export class FindAllProjectMembers {
  public static readonly type = '[Project/Users/List] FindAllProjectMembers';
  constructor(
    public searchTerm?: string,
    public pageNumber?: number,
  ) {}
}
